/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/display-name */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import GroupSetting from "../Groups/GroupSetting";
import {
  setChatboardSelectedTab,
  setShowPinnedMessage,
} from "../redux/chatSlice";
import UserProfileModal from "../models/UserProfileModal";
import {
  FilesFillIcon,
  FilesIcon,
  MessageFillIcon,
  MessageIcon,
  PinFillIcon,
  PinIcon,
  SearchIcon,
  UserIcon,
} from "../../assets/icons/svg";
import { getObjectLength } from "../Helpers/common";

const ChatBoardHeader = () => {
  const dispatch = useDispatch();

  const {
    authUserDetail: { sessionThemeData } = {},
    chat: {
      attendeeData,
      selectedLanguage,
      chatboardSelectedTab,
      unreadThreadListObj,
      chatRoom,
    } = {},
  } = useSelector((state) => state);

  const activeUnreadThreadList = unreadThreadListObj[chatRoom];

  const [showSetting, setShowSetting] = useState(false);
  const [showUserSetting, setShowUserSetting] = useState(false);
  const [settingsTab, setSettingsTab] = useState("");
  const [isOpenModal, setIsOpenModal] = useState(false);

  let username = attendeeData?.name;
  let role = attendeeData?.role_name;
  // let shows = false;
  let groupId = "";
  let showUser = false;
  let useravtar = attendeeData?.user_profile_image;
  if (attendeeData.type == "group") {
    groupId = attendeeData?.groupId;
    username = attendeeData?.groupName;
    role = attendeeData?.description;
    // shows = true;
    showUser = true;
    useravtar = "";
  }

  useEffect(() => {
    setShowUserSetting(showUser);
  }, [groupId]);

  let GroupSettingProps = {
    show: showSetting,
    settingsTab,
  };

  const openProfileModal = () => {
    setIsOpenModal(true);
  };

  const closeModal = () => {
    setIsOpenModal(false);
  };

  const handleTabing = (tab) => {
    if (tab === "pins") {
      dispatch(setShowPinnedMessage(true));
    }
    dispatch(setChatboardSelectedTab(tab));
  };

  const TABS = [
    {
      key: "messages",
      label: "Messages",
      activeIcon: MessageFillIcon,
      icon: MessageIcon,
      aria: "messages",
    },
    {
      key: "pins",
      label: "Pinned",
      activeIcon: PinFillIcon,
      icon: PinIcon,
      aria: "pins",
    },
    {
      key: "files",
      label: "Files",
      activeIcon: FilesFillIcon,
      icon: FilesIcon,
      aria: "files",
    },
    {
      key: "search",
      label: "Search",
      activeIcon: SearchIcon,
      icon: SearchIcon,
      aria: "search",
    },
  ];

  // Conditionally add the "messages" tab if there are unread threads
  if (activeUnreadThreadList?.length > 0) {
    TABS.push({
      key: "thread",
      label: "Unread Threads",
      activeIcon: MessageFillIcon,
      icon: MessageIcon,
      aria: "thread",
    });
  }

  useEffect(() => {
    if (activeUnreadThreadList?.length === 0) {
      dispatch(setChatboardSelectedTab("messages"));
    }
  }, [activeUnreadThreadList]);

  return (
    <>
      <div className="head">
        <div
          className="user position-relative cursor-pointer"
          onClick={(e) => {
            if (attendeeData.type === "group") {
              setSettingsTab("#about-tab");
              setShowSetting(true);
            } else {
              openProfileModal(e);
            }
          }}
        >
          <div className="dropdown-container">
            <div className="avatar cursor-pointer">
              {!useravtar ? (
                sessionThemeData ? (
                  <img src="./assets/images/group-dark.png" alt="Group" />
                ) : (
                  <img src="./assets/images/group-light.png" alt="Group" />
                )
              ) : (
                <img className="h-100" src={`${useravtar}`} alt="..."></img>
              )}
              {attendeeData.type !== "group" && (
                <span
                  className={`status position-absolute head-online ${
                    attendeeData?.online === true && "online"
                  }`}
                ></span>
              )}
            </div>
          </div>
          <div className="d-flex flex-column contact_info">
            <div className="name">{username}</div>
            <span className="designation">{role}</span>
          </div>
        </div>

        <div className="bar_tool">
          {groupId !== "" ? (
            <div
              className="d-flex"
              data-tip
              data-for="view-all-members"
              onClick={() => {
                setSettingsTab("#members-tab");
                setShowSetting(true);
              }}
            >
              <div className="links text--light px-2">
                <UserIcon width={18} height={18} />
                {attendeeData?.attendeeId?.length}&nbsp;Members
              </div>
            </div>
          ) : null}
          {/* <div className="d-flex">
            <div className="links text--light">
              <svg
                width="20"
                height="20"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="m12,3C6.49,3,2,7.49,2,13v6c0,.55.45,1,1,1h3c.55,0,1-.45,1-1v-5c0-.55-.45-1-1-1h-2c0-4.41,3.59-8,8-8s8,3.59,8,8h-2c-.55,0-1,.45-1,1v5c0,.55.45,1,1,1h3c.55,0,1-.45,1-1v-6c0-5.51-4.49-10-10-10Z"></path>
              </svg>
            </div>
          </div> */}
          <div className="d-flex">
            {showUserSetting ? (
              <UserSettingDisplay
                key={groupId}
                setShowSetting={setShowSetting}
                setSettingsTab={setSettingsTab}
              />
            ) : null}
          </div>
        </div>
      </div>
      {/* Tabs */}
      <div className="tab-container">
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          {TABS?.map((val) => {
            if (!getObjectLength(val)) return null;
            const {
              key,
              label,
              activeIcon: ActiveIcon,
              icon: Icon,
              aria,
            } = val || {};
            const isActive = chatboardSelectedTab === key;

            return (
              <li className="nav-item" role="presentation" key={key}>
                <button
                  className={`nav-link d-flex align-items-center ${
                    isActive ? "active" : ""
                  }`}
                  id={`${key}-tab`}
                  data-toggle="tab"
                  data-target={`#${aria}`}
                  type="button"
                  role="tab"
                  aria-controls={aria}
                  aria-selected={isActive}
                  onClick={() => handleTabing(key)}
                >
                  <span className="mr-1 d-inline-flex align-items-center">
                    {isActive ? (
                      <ActiveIcon
                        width="16"
                        height="16"
                        className="flip-icon"
                      />
                    ) : (
                      <Icon width="16" height="16" className="flip-icon" />
                    )}
                  </span>
                  <strong>{label}</strong>
                </button>
              </li>
            );
          })}
        </ul>
      </div>

      {showSetting && (
        <GroupSetting
          {...GroupSettingProps}
          handleClose={() => {
            setShowSetting(false);
            setSettingsTab("");
          }}
        />
      )}

      {isOpenModal && (
        <UserProfileModal
          show={true}
          userInfo={attendeeData}
          closeModal={closeModal}
          isOpenModal={isOpenModal}
          selectedLanguage={selectedLanguage}
        />
      )}
    </>
  );
};

export default memo(ChatBoardHeader);

const UserSettingDisplay = React.memo(({ setShowSetting, setSettingsTab }) => {
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <span
      className="alink three-dot icon_container"
      onClick={() => {
        setShowSetting(true);
        setSettingsTab("#settings-tab");
      }}
    >
      {/* <svg width="3.5px" viewBox="10 4 4 16">
        <path
          fill="#b8c0c9"
          d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        ></path>
      </svg> */}
      <svg
        width="20"
        height="20"
        viewBox="0 0 16 16"
        className="text-extra-light-gray-color"
      >
        <path
          d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492M5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0"
          fill="currentColor"
        />
        <path
          d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
});
